<template>
  <v-container
    id="detalhe-ranking-fornecedores"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-container>
          <dashboard-filtro-datas
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
          />
        </v-container>
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row
                    no-gutters
                  >
                    <v-col
                      md="1"
                      offset-md="5"
                    >
                      <v-card
                        class="pa-2"
                        outlined
                        tile
                      >
                        <div class="text-center">
                          <span>
                            Fornecedores
                          </span><br>
                          <span
                            id="valorFornecedores"
                            :style="styleObjectIcon"
                          >
                            {{ valorFornecedores }}
                          </span>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col
                      md="5"
                      offset-md="1"
                    >
                      <v-card
                        id="filtroFornecedores"
                        class="pa-1"
                        outlined
                        tile
                      >
                        <div class="text-center">
                          Filtrar fornecedores com valores
                        </div><br>
                        <v-row id="filtrosFornecedores">
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            lg="3"
                          >
                            <div
                              id="todosFornecedores"
                              class="text-center"
                            >
                              <v-icon
                                @click="expandedTodos()"
                              >
                                mdi-check-all
                              </v-icon><br>
                              <span>Todos</span>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            lg="3"
                          >
                            <div class="text-center">
                              <v-icon
                                @click="expandedAberto()"
                              >
                                mdi-bell-plus-outline
                              </v-icon><br>
                              <span>Aberto</span>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            lg="3"
                          >
                            <div class="text-center">
                              <v-icon
                                @click="expandedAtraso()"
                              >
                                mdi-alert-circle-outline
                              </v-icon><br>
                              <span>Em atraso</span>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            lg="3"
                          >
                            <div class="text-center">
                              <v-icon
                                @click="expandedPago()"
                              >
                                mdi-thumb-up-outline
                              </v-icon><br>
                              <span>Valores Pagos</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="error">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        id="idTable"
                        style="overflow-x: auto;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 28%;"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 12%;"
                              >
                                Código lançamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 12%;"
                              >
                                Qtd Lançamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 12%;"
                              >
                                Total
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 12%;"
                              >
                                Share % no total
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 12%;"
                              >
                                Pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 12%;"
                              >
                                A pagar
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(item, index) in dadosDetalhamento"
                            :key="item.id"
                          >
                            <!-- Linha principal -->
                            <tr>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 28%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 12%;"
                              >
                                <button
                                  @click="toggleExpand(index)"
                                >
                                  {{ expanded.includes(index) ? '▲' : '▼' }}
                                </button>
                                {{ item.cod_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 12%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 12%;"
                              >
                                {{ item.total }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 12%;"
                              >
                                {{ item.share_total }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 12%;"
                                :style="getColorPago(item.pago)"
                              >
                                {{ item.pago }}
                              </td>
                              <td
                                class="text-right"
                                width="140px"
                                :style="getColorPagar(item.pagar)"
                              >
                                {{ item.pagar }}
                              </td>
                            </tr>
                            <!-- Linha expandida -->
                            <tr
                              v-if="expanded.includes(index)"
                              :key="'expanded-' + item.id"
                            >
                              <td colspan="10">
                                <table
                                  id="tableExpandida"
                                  style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                                >
                                  <tbody>
                                    <tr
                                      v-for="(sub, idx) in item.dadosCodLancamento"
                                      :key="idx"
                                    >
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left; width: 40%;"
                                      >
                                        {{ sub.nome_reduzido }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left; width: 12%;"
                                      >
                                        {{ sub.cod_lancamento }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 12%;"
                                      >
                                        {{ sub.qtd_lancamento }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 12%;"
                                      >
                                        {{ sub.total }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 12%;"
                                      >
                                        {{ dados.share_total }} %
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 12%;"
                                        :style="getColorPago(sub.pago)"
                                      >
                                        R$ {{ sub.pagar }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 12%;"
                                        :style="getColorPagar(sub.pagar)"
                                      >
                                        R$ {{ sub.pagar }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import ContasPagar from '../../../../../services/contaspagar'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardContasPagarRankingFornecedores',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectValorPago: {
        color: '#4780b8',
      },
      styleObjectValorAberto: {
        color: '#f27686',
      },
      styleObjectIcon: {
        color: '#4780b8',
      },
      paginaEnable: false,
      permissaoContasReceber: '',
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      menu: false,
      menu1: false,
      link: '',
      headersDetalhamento: [
        { text: 'Nome reduzido', value: 'nome_reduzido', width: '300px', class: 'black--text title' },
        { text: 'Código lançamento', value: 'cod_lancamento', width: '200px', class: 'black--text title' },
        { text: 'Qtd Lançamento', value: 'qtd_lancamento', width: '160px', align: 'right', class: 'black--text title' },
        { text: 'Total', value: 'total', width: '130px', align: 'right', class: 'black--text title' },
        { text: 'Share % no total', value: 'share_total', width: '150px', align: 'right', class: 'black--text title' },
        { text: 'Pago', value: 'pago', width: '140px', align: 'right', class: 'black--text title' },
        { text: 'A pagar', value: 'pagar', width: '140px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      dadosDetalhamentoTodos: [],
      dadosDetalhamentoAberto: [],
      dadosDetalhamentoAtraso: [],
      dadosDetalhamentoPago: [],
      expandDetalhamento: false,
      iconeSubcategoria: 'mdi-plus',
      expandSubcategoria: false,
      valorFornecedores: 0,
      valorFornecedoreTotal: 0,
      valorFornecedoresAberto: 0,
      valorFornecedoresAtraso: 0,
      valorFornecedoresPago: 0,
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      expanded: [],
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      console.log(window.location.href)

      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        eventEmit.$emit('atualizar_texto', 'Contas Pagar')
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select

        this.updateDados()
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0).toISOString().substr(0, 10)

        if (date > dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser maiores que 2 meses da data atual')

          var data = new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0).toISOString().substr(0, 10)

          const [year, month, day] = data.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toISOString().substr(0, 10)

        if (date < dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser menores que 2 meses da data atual')

          const [year, month, day] = dataLimite.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      updateDados () {
        this.dadosDetalhamento = []

        this.showContasPagarRankingFornecedores()
      },

      async showContasPagarRankingFornecedores () {
        this.loading = true

        await ContasPagar.showDadosDelhamentoPagarRankingFornecedores(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorFornecedoreTotal = resposta.data.qtdFornecedores
            this.valorFornecedores = this.valorFornecedoreTotal

            this.dadosDetalhamentoTodos = resposta.data.dadosExibicao.map((item) => {
              var listaDetalhamento = ({
                nome_reduzido: item.nome_reduzido,
                cod_lancamento: item.cod_lancamento,
                qtd_lancamento: item.qtd_lancamento,
                share_total: item.share_total + '%',
                shareAux: parseFloat(item.share_total),
                total: parseFloat(item.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                totalAux: parseFloat(item.total),
                pago: parseFloat(item.pago).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagoAux: parseFloat(item.pago),
                pagar: parseFloat(item.aberto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagarAux: parseFloat(item.aberto),
                dias_vencido: item.dias_vencido,
                dadosCodLancamento: item.dadosCodLancamento,
                icone: item.icone,
                expandir: item.expandir,
              })

              return listaDetalhamento
            })

            this.dadosDetalhamento = this.dadosDetalhamentoTodos
          } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      expandedTodos () {
        try {
          this.loading = true

          this.dadosDetalhamento = []
          this.valorFornecedores = 0

          this.dadosDetalhamento = this.dadosDetalhamentoTodos
          this.valorFornecedores = this.valorFornecedoreTotal
        } finally {
          this.loading = false
        }
      },

      expandedAberto () {
        try {
          this.loading = false
          this.dadosDetalhamento = []
          this.dadosDetalhamentoAberto = []
          this.valorFornecedores = 0

          var total = 0
          var pago = 0
          var pagar = 0
          var share = 0

          for (var i = 0; i < this.dadosDetalhamentoTodos.length; i++) {
            if (this.dadosDetalhamentoTodos[i].dias_vencido === 0 && this.dadosDetalhamentoTodos[i].pagarAux > 0) {
              const dadosAux = {
                nome_reduzido: this.dadosDetalhamentoTodos[i].nome_reduzido,
                cod_lancamento: this.dadosDetalhamentoTodos[i].cod_lancamento,
                qtd_lancamento: this.dadosDetalhamentoTodos[i].qtd_lancamento,
                share_total: this.dadosDetalhamentoTodos[i].share_total,
                total: parseFloat(this.dadosDetalhamentoTodos[i].totalAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                totalAux: parseFloat(this.dadosDetalhamentoTodos[i].totalAux),
                pago: parseFloat(this.dadosDetalhamentoTodos[i].pagoAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagoAux: parseFloat(this.dadosDetalhamentoTodos[i].pago),
                pagar: parseFloat(this.dadosDetalhamentoTodos[i].pagarAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagarAux: parseFloat(this.dadosDetalhamentoTodos[i].aberto),
                dias_vencido: this.dadosDetalhamentoTodos[i].dias_vencido,
                dadosCodLancamento: this.dadosDetalhamentoTodos[i].dadosCodLancamento,
                icone: this.dadosDetalhamentoTodos[i].icone,
                expandir: this.dadosDetalhamentoTodos[i].expandir,
              }

              this.dadosDetalhamentoAberto.push(dadosAux)
              total += parseFloat(this.dadosDetalhamentoTodos[i].totalAux)
              pago += parseFloat(this.dadosDetalhamentoTodos[i].pagoAux)
              pagar += parseFloat(this.dadosDetalhamentoTodos[i].pagarAux)
              share += parseFloat(this.dadosDetalhamentoTodos[i].shareAux)
            }
          }

          const dadosTotal = {
            nome_reduzido: 'Total',
            total: total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            pago: pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            pagar: pagar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            share_total: share.toFixed(2).toString().replace('.', ',') + '%',
          }

          this.valorFornecedoresAberto = this.dadosDetalhamentoAberto.length

          this.dadosDetalhamentoAberto.push(dadosTotal)

          this.dadosDetalhamento = this.dadosDetalhamentoAberto
          this.valorFornecedores = this.valorFornecedoresAberto
        } finally {
          this.loading = false
        }
      },

      expandedAtraso () {
        try {
          this.loading = true

          this.dadosDetalhamento = []
          this.dadosDetalhamentoAtraso = []
          this.valorFornecedores = 0

          var total = 0
          var pago = 0
          var pagar = 0
          var share = 0

          for (var i = 0; i < this.dadosDetalhamentoTodos.length; i++) {
            if (this.dadosDetalhamentoTodos[i].dias_vencido > 0) {
              const dadosAux = {
                nome_reduzido: this.dadosDetalhamentoTodos[i].nome_reduzido,
                cod_lancamento: this.dadosDetalhamentoTodos[i].cod_lancamento,
                qtd_lancamento: this.dadosDetalhamentoTodos[i].qtd_lancamento,
                share_total: this.dadosDetalhamentoTodos[i].share_total,
                total: parseFloat(this.dadosDetalhamentoTodos[i].totalAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                totalAux: parseFloat(this.dadosDetalhamentoTodos[i].total),
                pago: parseFloat(this.dadosDetalhamentoTodos[i].pagoAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagoAux: parseFloat(this.dadosDetalhamentoTodos[i].pago),
                pagar: parseFloat(this.dadosDetalhamentoTodos[i].pagarAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagarAux: parseFloat(this.dadosDetalhamentoTodos[i].aberto),
                dias_vencido: this.dadosDetalhamentoTodos[i].dias_vencido,
                dadosCodLancamento: this.dadosDetalhamentoTodos[i].dadosCodLancamento,
                icone: this.dadosDetalhamentoTodos[i].icone,
                expandir: this.dadosDetalhamentoTodos[i].expandir,
              }

              this.dadosDetalhamentoAtraso.push(dadosAux)
              total += parseFloat(this.dadosDetalhamentoTodos[i].totalAux)
              pago += parseFloat(this.dadosDetalhamentoTodos[i].pagoAux)
              pagar += parseFloat(this.dadosDetalhamentoTodos[i].pagarAux)
              share += parseFloat(this.dadosDetalhamentoTodos[i].shareAux)
            }
          }

          this.valorFornecedores = this.dadosDetalhamentoAtraso.length

          const dadosTotal = {
            nome_reduzido: 'Total',
            total: total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            pago: pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            pagar: pagar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            share_total: share.toFixed(2).toString().replace('.', ',') + '%',
          }

          this.dadosDetalhamentoAtraso.push(dadosTotal)

          this.dadosDetalhamento = this.dadosDetalhamentoAtraso
        } finally {
          this.loading = false
        }
      },

      expandedPago () {
        try {
          this.loading = true

          this.dadosDetalhamento = []
          this.dadosDetalhamentoPago = []
          this.valorFornecedores = 0

          var total = 0
          var pago = 0
          var pagar = 0
          var share = 0

          for (var i = 0; i < this.dadosDetalhamentoTodos.length; i++) {
            if (this.dadosDetalhamentoTodos[i].dias_vencido === 0 && this.dadosDetalhamentoTodos[i].pagarAux === 0) {
              const dadosAux = {
                nome_reduzido: this.dadosDetalhamentoTodos[i].nome_reduzido,
                cod_lancamento: this.dadosDetalhamentoTodos[i].cod_lancamento,
                qtd_lancamento: this.dadosDetalhamentoTodos[i].qtd_lancamento,
                share_total: this.dadosDetalhamentoTodos[i].share_total,
                total: parseFloat(this.dadosDetalhamentoTodos[i].totalAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                totalAux: parseFloat(this.dadosDetalhamentoTodos[i].total),
                pago: parseFloat(this.dadosDetalhamentoTodos[i].pagoAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagoAux: parseFloat(this.dadosDetalhamentoTodos[i].pago),
                pagar: parseFloat(this.dadosDetalhamentoTodos[i].pagarAux).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagarAux: parseFloat(this.dadosDetalhamentoTodos[i].aberto),
                dias_vencido: this.dadosDetalhamentoTodos[i].dias_vencido,
                dadosCodLancamento: this.dadosDetalhamentoTodos[i].dadosCodLancamento,
                icone: this.dadosDetalhamentoTodos[i].icone,
                expandir: this.dadosDetalhamentoTodos[i].expandir,
              }

              this.dadosDetalhamentoPago.push(dadosAux)
              total += parseFloat(this.dadosDetalhamentoTodos[i].totalAux)
              pago += parseFloat(this.dadosDetalhamentoTodos[i].pagoAux)
              pagar += parseFloat(this.dadosDetalhamentoTodos[i].pagarAux)
              share += parseFloat(this.dadosDetalhamentoTodos[i].shareAux)
            }
          }

          this.valorFornecedores = this.dadosDetalhamentoPago.length

          const dadosTotal = {
            nome_reduzido: 'Total',
            total: total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            pago: pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            pagar: pagar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            share_total: share.toFixed(2).toString().replace('.', ',') + '%',
          }

          this.dadosDetalhamentoPago.push(dadosTotal)

          this.dadosDetalhamento = this.dadosDetalhamentoPago
        } finally {
          this.loading = false
        }
      },

      expandedCodLancamento (value) {
        if (value.icone === 'mdi-plus') {
          this.expandDetalhamento = true
          value.expandir = true
          value.icone = 'mdi-minus'
        } else {
          this.expandDetalhamento = false
          value.icone = 'mdi-plus'
          value.expandir = false
        }
      },

      getColorPagar (value) {
        return 'color: #f27686'
      },

      getColorPago () {
        return 'color: #4780b8'
      },

      getNomeReduzido (value) {
        return 'color: transparent'
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      /* max-height: 500px; */
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    /* max-height: 500px; */
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #valorFornecedores
    font-size: 20px

  #filtrosFornecedores
    font-size: 12px
    margin: -2rem 0 -1rem 0

  #bloco1
    margin-left: -5rem

  #ul_product
    list-style-type: none

  #headerTablePrincipal
    margin: -2rem 0 0 0

  #dadosId
    margin: -3rem 0 0 -1rem

  #idDadosNomeReduzidoFornecedores
    margin: -1rem 0 0 0

  #idDadosCodLancamentoFornecedores
    margin: -1rem 0 0 0

  #idDadosQtdLancamentoFornecedores
    margin: -1rem 0 0 0

  #idDadosTotalFornecedores
    margin: -1rem 0 0 0

  #idDadosShareTotalFornecedores
    margin: -1rem 0 0 0

  #idDadosAPagarFornecedores
    margin: -1rem 0 0 0

  #idDadosPagoFornecedores
    margin: -1rem 0 0 0

  #dividerTr
    margin: -1rem 0 0 0

  #headers
    margin: -1.5rem 0 1rem 0

  #dadosLancamentoFornecedores
    margin: 0 0 0 6rem

  #dadosQtdLancamentoFornecedores
    margin: 0 0 0 9.3rem

  #dadosShareTotalFornecedores
    margin: 0 -2rem 0 2rem

  #dadosPagoFornecedores
    margin: 0 -2rem 0 2rem

  #dadosPagarFornecedores
    margin: 0 -2rem 0 2rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
